
import Vue from 'vue';

export default Vue.extend({
  name: 'BaseTextarea',
  props: {
    labelClasses: {
      type: String,
    },
    inputClasses: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    resize: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  methods: {
    callback: function (e) {
      this.$emit('input', e);
    },
    onBlur: function(e) {
      this.$refs.input.classList.remove('has-error');
      this.$emit('blur', e);
    },
  },
});
